var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairtrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Organic-Plant-Circle--Streamline-Freehand.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Organic Plant Circle Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.75 3.87A12.62 12.62 0 0 0 12.43 0 15.78 15.78 0 0 0 7.2 0.91a10 10 0 0 0 -5.65 5.76 17.16 17.16 0 0 0 -1 7.16c0.1 0.59 0.53 1.56 0.94 1.15s-0.28 -0.26 -0.35 -1.59A17.1 17.1 0 0 1 2.36 7 9.24 9.24 0 0 1 7.6 2a15.13 15.13 0 0 1 4.81 -0.82 12 12 0 0 1 7.68 3.44c2.16 1.91 3.11 6.35 2.56 9.52a0.34 0.34 0 0 0 0.67 0.13c0.68 -3.41 -0.21 -8.18 -2.57 -10.4Z",
    fill: "#00b1cc",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47 19.14c-0.49 -0.08 -1.29 -3.17 -2 -2.92 -0.5 0.17 0 1.86 0.29 2.33s1.1 1.36 1.73 1.27a0.34 0.34 0 0 0 -0.02 -0.68Z",
    fill: "#00b1cc",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86 22c-1.63 -1.05 -1.65 -1.44 -2.08 -1.21s0.32 1.11 0.65 1.51a3.23 3.23 0 0 0 1.26 0.87c0.57 0.22 1.93 0.49 1.93 -0.12 0 -0.49 -0.26 -0.14 -1.76 -1.05Z",
    fill: "#00b1cc",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.48 22.53c-5.13 0.58 -4.56 0.49 -4.77 0.69s-0.16 0.43 0.27 0.54c0.28 0.08 1.3 0.2 1.55 0.24 2.51 0 2.69 -0.76 3 -0.79a0.34 0.34 0 0 0 -0.05 -0.68Z",
    fill: "#00b1cc",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.05 20.09c-1 1.14 -3 1.8 -2.73 2.24 0 0.06 0.08 0.19 0.25 0.18a6.73 6.73 0 0 0 2 -0.66c0.51 -0.33 1.28 -1.16 1.18 -1.76a0.34 0.34 0 0 0 -0.7 0Z",
    fill: "#00b1cc",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.59 16a0.35 0.35 0 0 0 -0.34 0.34c0 0.09 -1.63 2.58 -1.66 2.66s-0.06 0.34 0 0.4a0.34 0.34 0 0 0 0.57 -0.05 3.47 3.47 0 0 0 1.45 -1.57c0.29 -0.63 0.6 -1.78 -0.02 -1.78Z",
    fill: "#00b1cc",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.65 13.22c0.83 -0.51 1.48 -0.64 1.24 -1.08a0.35 0.35 0 0 0 -0.47 -0.14c-0.46 0.23 -0.92 0.36 -1.36 0.6a7.39 7.39 0 0 0 -3.17 4.4 9.12 9.12 0 0 0 -5.12 -7.14 0.3 0.3 0 0 0 -0.29 0.52c2.89 1.83 4.42 5.67 5 9 0 0.28 0 0.56 -0.06 0.84a0.32 0.32 0 0 0 0.27 0.33c0.58 0 0.17 -0.94 1.5 -3.84a8.76 8.76 0 0 1 2.46 -3.49Z",
    fill: "#82e1f2",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9a1 1 0 0 0 -0.48 -1c-0.37 -0.18 -1 -0.09 -3 0a7.41 7.41 0 0 0 -2.53 0.55c-2.09 1 -3.85 3.83 -3.1 6.21a0.3 0.3 0 0 0 0.58 -0.16c-0.54 -2 1.15 -4.4 2.93 -5.09a7.81 7.81 0 0 1 2.21 -0.37c2.52 -0.13 2 -0.12 2.27 -0.06a19.71 19.71 0 0 1 -1.45 4 4.5 4.5 0 0 1 -3.56 2.49 0.34 0.34 0 0 0 0 0.68 5.31 5.31 0 0 0 4.35 -2.68A15.43 15.43 0 0 0 21 9Z",
    fill: "#82e1f2",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87 14.36c-0.4 0.68 -1.39 0.37 -2 -0.14 -1 -0.86 -1.42 -2.87 -1.93 -4.25a11.31 11.31 0 0 1 -0.65 -1.49 6.52 6.52 0 0 1 2.24 -0.31 4.8 4.8 0 0 1 4 3.15 0.34 0.34 0 1 0 0.63 -0.24 5.67 5.67 0 0 0 -4.4 -3.92 5.76 5.76 0 0 0 -2.64 0.21c-0.58 0.16 -1.14 0.4 -1.11 1a2.1 2.1 0 0 0 0.29 0.7c1.3 2.84 1.22 3 1.76 4.1 1.36 2.64 3.67 2.77 4.36 1.5a0.3 0.3 0 0 0 -0.55 -0.31Z",
    fill: "#82e1f2",
    fillRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairtrade);
export default __webpack_public_path__ + "static/media/fairtrade.c58436976d0dc0612b1f54f97c78b6a4.svg";
export { ForwardRef as ReactComponent };